// @ts-nocheck
/* eslint-disable */
export const outlineMinusIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 8H4"/></svg>`,
    name: 'outline-minus' as const
};